export enum DialogDeleteDataViewEnum {
	FORM = 'FORM',
	CONFIRM = 'CONFIRM',
}
